export const BUCKETS = ['PRE_JOB', 'POST_JOB', 'OTHER'];
